<script lang="ts" setup>
definePageMeta({
  middleware: ['03-pharmacy-related'],
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
